module.exports = __webpack_public_path__ + "static/img/B.5a3a268.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ssxxg/B.png
// module id = 6HCe
// module chunks = 0